import request from '../utils/request';
import { IResult } from '../global';

const documentApi = {
  one: (id: string | number, force?: boolean) => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url:
          '/api/v2/gallerydocument/getone?id=' +
          id +
          (force ? `&_t=${Date.now()}` : ''),
        method: 'get'
      }).then(res => {
        if (!res.error) {
          resolve(res);
        } else {
          reject();
        }
      });
    });
  },
  oneByMedium: (id: string | number, force?: boolean) => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: '/api/v2/gallerydocument/getone?medium_id=' + id,
        method: 'get',
        headers: force
          ? {
              Authorization: Date.now()
            }
          : {}
      }).then(res => {
        if (!res.error) {
          resolve(res);
        } else {
          reject();
        }
      });
    });
  },
  getClipList: (id: string | number, begin_at: number, end_at: number) => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: '/api/v2/gallerydocument/getcliplist',
        data: {
          id: id,
          start: begin_at,
          end: end_at
        }
      }).then(resolve);
    });
  }
};

export default documentApi;
